"use client";

import { useEffect, useState } from "react";
import { m as motion, AnimatePresence } from "framer-motion";

export default function IntroLoader() {
  const [show, setShow] = useState(false);
  
  useEffect(() => {
    // Session key v4 to guarantee fresh state
    const hasShown = sessionStorage.getItem("portfolio-opener-curtain-v4");
    
    if (!hasShown) {
        setShow(true);
        const timer = setTimeout(() => {
            setShow(false);
            sessionStorage.setItem("portfolio-opener-curtain-v4", "true");
        }, 350);

        return () => clearTimeout(timer);
    }
  }, []);

  const curtainTransition = { duration: 0.4, ease: [0.76, 0, 0.24, 1] };

  return (
    <AnimatePresence>
      {show && (
        <div className="fixed inset-0 z-[1000000] flex flex-col overflow-hidden pointer-events-none">
            {/* Top Half - SACHIN */}
            <motion.div
                initial={{ y: 0 }}
                animate={{ y: 0 }}
                exit={{ y: "-100%" }}
                transition={curtainTransition}
                className="w-full h-1/2 bg-black flex flex-col justify-end items-center pointer-events-auto"
            >
                <div className="overflow-hidden">
                    <motion.h1
                        initial={{ y: "100%" }}
                        animate={{ y: 0 }}
                        transition={{ duration: 0.3, ease: "easeOut" }}
                        className="text-[15vw] md:text-[10vw] font-black uppercase text-white leading-none tracking-tighter"
                    >
                        Sachin
                    </motion.h1>
                </div>
            </motion.div>

            {/* Bottom Half - SHARMA */}
            <motion.div
                initial={{ y: 0 }}
                animate={{ y: 0 }}
                exit={{ y: "100%" }}
                transition={curtainTransition}
                className="w-full h-1/2 bg-black flex flex-col justify-start items-center pointer-events-auto"
            >
                <div className="overflow-hidden">
                    <motion.h1
                        initial={{ y: "-100%" }}
                        animate={{ y: 0 }}
                        transition={{ duration: 0.3, ease: "easeOut" }}
                        className="text-[15vw] md:text-[10vw] font-black uppercase text-zinc-600 leading-none tracking-tighter"
                    >
                        Sharma
                    </motion.h1>
                </div>
            </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
